import * as React from 'react';
import { Link } from 'react-router-dom';
import { Tokenizer } from '@fnv-core/tokens';
import { Slug } from '@fnv-core/utils';
import { MijnFNVPageContext } from '../presentational/pages/helpers/MijnFNVPageContext';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers, IOption } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';

class StyledLinkBlocks extends React.Component<FormControlProps> {
    constructor(props: FormControlProps) {
        super(props);        
    }

    componentDidMount() {
        if (ComponentStoreHelpers.hasDatasource(this)) {
            ComponentStoreHelpers.setFormFieldData(this, []);
            ComponentStoreHelpers.getData(this);
        }
    }

    unmounted : boolean = false;
    componentWillUnmount() {
        this.unmounted = true;
    }

    getUrlWithId = (url) => {
        return Tokenizer.replaceTokens(url, [this.context.pathParam || '']);
    }

    render() {
        function getId(component: React.Component<FormControlProps>, option: IOption) {
            return `${component.props.formFieldDefinition.name}-${option.value}`;
        }

        const fieldProperties = {
            ...FormControlHelpers.baseProperties(this),
            ...FormControlHelpers.onChangeSetValueViaEvent(this),
            onBlur: this.props.field.onBlur
        };

        const options = ComponentStoreHelpers.getListData(this);

        return (
            <div className={'form-group' + this.props.visibilityClass + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-styled-linkblocks-form-group'}>
                <LabelAndPopover 
                    className="form__radio-label"
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="mijn-fnv__link-block-container">
                    {options.map((option: IOption, index: number) => {
                        return (
                            <div
                                key={getId(this, option) + "_" + index}
                                className="mijn-fnv__link-block"
                            >
                                <Link to={this.getUrlWithId(option.value)}
                                    className={"mijn-fnv__link-block-link " + Slug.fromString(option.label) + 
                                        " " + (this.props.formFieldDefinition.defaultValue == option.value ? "mijn-fnv__link-block-link--selected" : "") } >
                                    <span className="mijn-fnv__link-block-link-text">
                                        <span>{option.label}</span>
                                    </span>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
StyledLinkBlocks.contextType = MijnFNVPageContext;

export { StyledLinkBlocks };
